<div class="container-fluid plan-distribution-container" *ngIf="planDetails">
  <div class="row" style="margin-top: 13px">
    <div class="col">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a routerLink="/plans">
            {{"plan.page.title" | translate}}
          </a>
          <svg style="width: 14px;height: 14px;margin-left: 3px; fill:#212529">
            <use xlink:href="#icon-arrow-right" />
          </svg>
          <a [routerLink]="['..']">
            {{planName}}
          </a>
        </li>
      </ol>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col page-header plan-detail">
      <wfm-page-title title="{{'plan.dist.page.title'|translate}}"></wfm-page-title>
    </div>
    <div class="col text-right header-actions">
      <!--<div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-secondary"  [ngClass]="{'disabled': _isLoading}" [disabled]="_isLoading" id="dropdownSettings" ngbDropdownToggle pTooltip="{{'plan.options'|translate}}" tooltipPosition="left">
            <svg style="width: 16px;height: 16px; fill: #777f85">
              <use xlink:href="#icon-more" />
            </svg>

          </button>

          <div ngbDropdownMenu aria-labelledby="dropdownSettings">
            <button class="dropdown-item" (click)="showConvertToActiveDialog()" *ngIf="_convertToActiveFeature" [disabled]="!_userHasModify" id="btn-convert">
              <i class="icon icon-status_assigned"></i>
              {{"plan.convert.active"|translate}}
            </button>
            <button *ngIf="canExportCsv()" class="dropdown-item" (click)="onBtnExport()" id="btn-export">
              <i class="icon icon-CSV"></i> {{"plan.exportcsv"|translate}}
            </button>
            <button class="dropdown-item" (click)="showPlanSettingsDlg()" id="btn-settings">
              <svg style="width: 20px;height: 20px;">
                <use xlink:href="#icon-setup" />
              </svg> {{"plan.settings"|translate}}
            </button>
          </div>
        </div>
      </div>-->
      <button id="cancel" class="btn btn-secondary btn-lg no-right-margin" [ngClass]="{'disabled': _isEditing}" [disabled]="_isEditing" [routerLink]="['..']" title='{{"plan.dist.return.plan" | translate}}'>{{"plan.dist.return.plan" | translate}}</button>
      <button id="apply" (click)="applyChanges()" [ngClass]="{'disabled': _isLoading || _isGridValid==false || _isPristine || _isEditing}" class="btn btn-primary btn-lg no-right-margin" [disabled]="_isLoading || _isGridValid==false || _isPristine || _isEditing" title='{{"plan.apply.btn" | translate}}'>{{"plan.apply.btn" | translate}}</button>
      <breeze-button class="d-none" buttonText="Close" id="btn-cancel-plan" [isPrimary]="true" btnSizeClass="btn-lg no-right-margin">
      </breeze-button>

    </div>
  </div>
  <div class="row toolbar-container text-left no-gutters">
    <!--<div class="col-sm-2">
      <button id="toggle-chart-btn" class="btn btn-secondary btn-rect float-left" (click)="toggleChartButtonClicked()" *ngIf="_planChartFeature">
        <svg *ngIf="isChartView" style="width: 16px;height: 16px; fill: #777f85" id="icon-Horizontal-View" viewBox="0 0 20 20" width="100%" height="100%">
          <title>Grid View</title>
          <path d="M0 6h20v14h-20v-14zM2 8v4h4v-4h-4zM20 4v-4h-20v4h20zM18 12v-4h-4v4h4zM12 12v-4h-4v4h4zM18 18v-4h-4v4h4zM12 18v-4h-4v4h4zM6 18v-4h-4v4h4z"></path>
        </svg>
        <svg *ngIf="isChartView==false" style="width: 16px;height: 16px; fill: #777f85" id="icon-forecaster" viewBox="0 0 20 20" width="100%" height="100%">
          <title>Chart View</title>
          <path d="M18 16h-16c-0.6 0-1 0.4-1 1s0.4 1 1 1h16c0.6 0 1-0.4 1-1s-0.4-1-1-1z"></path>
          <path d="M3 13c0.3 0 0.5-0.1 0.7-0.3l5.1-5.6 1.6 2.1c0.2 0.2 0.4 0.4 0.7 0.4s0.6-0.1 0.8-0.3l4.1-3.9v1.6c0 0.6 0.4 1 1 1s1-0.4 1-1v-4c0-0.1 0-0.2-0.1-0.3 0 0 0-0.1 0-0.1 0-0.1-0.1-0.1-0.1-0.2 0 0 0-0.1-0.1-0.1-0.1-0.1-0.2-0.1-0.3-0.2 0 0 0 0 0 0-0.1-0.1-0.2-0.1-0.4-0.1 0 0 0 0 0 0h-4c-0.6 0-1 0.4-1 1s0.4 1 1 1h1.5l-3.2 3.1-1.6-2.2c-0.2-0.2-0.5-0.4-0.8-0.4s-0.6 0.1-0.8 0.3l-5.9 6.5c-0.4 0.4-0.3 1 0.1 1.4 0.2 0.2 0.5 0.3 0.7 0.3z"></path>
        </svg>
      </button>
    </div>-->
    <div class="vertical-align-middle">
      <span class="toolbar-label" >{{"plan.dist.mu.dropdown.label" | translate}}</span>
      <wfm-select
                  class="muSelectorDropDown toolbar-select"
                  selectName="name"
                  selectId="id"
                  [items]="muList"
                  [disabled]="_isLoading || _isGridValid==false"
                  (wfmSelectEvent)="updateSelectedMU($event)"
                  [selectedItem]="selectedMU">
      </wfm-select>
      <div class="embedded-info borderless" *ngIf="isReadOnly">
        <i class="icon-info"></i>
        {{"plan.dist.read.only.message" | translate}}
      </div>
    </div>
    <div class="text-right">
      <breeze-button buttonText="{{'plan.dist.discard.btn'|translate}}"
                     id="discard-btn"
                     *ngIf="!isReadOnly"
                     [isSecondary]="true"
                     [isDisabled]="_isLoading || _isPristine || _isEditing"
                     (clicked)="showDiscardDlg()"></breeze-button>
    </div>
  </div>
  <div class="row slider" >
    <div class="col slide" style="">
      <div class="table-list editable-grid multi-cell-edit" [ngClass]="{'read-only':isReadOnly}">
        <ag-grid-angular class="ag-theme-balham" style="width: 100%; height: 100%;"
                        [rowData]="rowData"
                        #grid
                        [rowClassRules]="rowClassRules"
                        [rowHeight]="36" [headerHeight]="39"
                        [columnDefs]="colDefs"
                        [rowData]="rowData"
                        [gridOptions]="gridOptions"
                        suppressNoRowsOverlay="true"
                        [suppressRowTransform]="true"
                        suppressCopyRowsToClipboard="true"
                        [modules]="modules"
                        enableRangeSelection="true"
                        rowSelection="multiple"
                        [enableFillHandle]="this.isReadOnly==false"
                        [stopEditingWhenCellsLoseFocus]="true"
                        [components]="frameworkComponents"
                        [loadingOverlayComponent]="'planLoadingOverlay'"
                        [context]="gridContext"
                        (gridReady)="onGridReady($event)"
                        [enableBrowserTooltips]="true"
                        [animateRows]="false"
                        (cellEditingStarted)="cellEditingStarted($event)"
                        (cellEditingStopped)="cellEditingStopped($event)"
                        (cellValueChanged)="cellValueChanged($event)">
        </ag-grid-angular>

      </div>
    </div>
  </div>
</div>
<wfm-task-progress [task]="task" *ngIf="task" [canCancel]="false">

</wfm-task-progress>
<wfm-plan-loading-overlay *ngIf="!planDetails"></wfm-plan-loading-overlay>
<p-toast position="bottom-right" [baseZIndex]="50">
</p-toast>
<div class="dialog-container"></div>
<svg width="10" height="10">
  <symbol id="icon-arrow-right" viewBox="5 0 30 30">
    <title>arrow-right</title>
    <path d="M15 8.8l-8.5-8.5c-0.4-0.4-1.1-0.4-1.5 0s-0.4 1.1 0 1.5l8 8-8 8.5c-0.4 0.4-0.4 1.1 0 1.5s1.1 0.4 1.5 0l8.5-9c0.3-0.3 0.3-0.6 0.3-0.9 0-0.5-0.1-0.9-0.3-1.1z"></path>
  </symbol>
  <symbol id="icon-more" viewBox="0 0 20 20">
    <path d="M12.2 2.2c0 1.215-0.985 2.2-2.2 2.2s-2.2-0.985-2.2-2.2c0-1.215 0.985-2.2 2.2-2.2s2.2 0.985 2.2 2.2z"></path>
    <path d="M12.2 10c0 1.215-0.985 2.2-2.2 2.2s-2.2-0.985-2.2-2.2c0-1.215 0.985-2.2 2.2-2.2s2.2 0.985 2.2 2.2z"></path>
    <path d="M12.2 17.8c0 1.215-0.985 2.2-2.2 2.2s-2.2-0.985-2.2-2.2c0-1.215 0.985-2.2 2.2-2.2s2.2 0.985 2.2 2.2z"></path>
  </symbol>
  <symbol id="icon-setup" viewBox="0 0 20 20">
    <title>setup</title>
    <path d="M18.2 10.5v-1l1.5-1.4c0.3-0.3 0.4-0.7 0.2-1l-0.8-2.1c-0.1-0.3-0.5-0.5-0.9-0.6l-2 0.1-0.7-0.7 0.1-2c0-0.4-0.2-0.7-0.6-0.9l-2.1-0.9c-0.1 0-0.2 0-0.4 0s-0.5 0.1-0.7 0.3l-1.4 1.5h-1l-1.3-1.5c-0.1-0.2-0.4-0.3-0.6-0.3s-0.3 0-0.4 0.1l-2.1 0.8c-0.3 0.2-0.6 0.5-0.5 0.9l0.1 2-0.7 0.8-2-0.1c-0.5 0-0.8 0.2-1 0.5l-0.8 2.1c-0.1 0.4-0.1 0.8 0.2 1l1.5 1.4v1l-1.5 1.4c-0.3 0.3-0.4 0.7-0.2 1l0.8 2.1c0.1 0.3 0.5 0.6 0.9 0.6 0 0 0 0 0 0l2-0.1 0.7 0.7-0.1 2c0 0.4 0.2 0.7 0.6 0.9l2.1 0.9c0.1 0 0.2 0 0.4 0 0.3 0 0.5-0.1 0.7-0.3l1.4-1.5h1l1.4 1.5c0.2 0.2 0.4 0.3 0.7 0.3 0.1 0 0.2 0 0.3-0.1l2.1-0.9c0.4-0.1 0.6-0.5 0.6-0.9l-0.1-2 0.7-0.7 2.1 0.1c0.4 0 0.7-0.2 0.8-0.6l0.9-2.1c0.1-0.3 0.1-0.8-0.2-1l-1.7-1.3zM17.5 13.5l-1.3-0.1h-0.9l-1.9 1.9v0.9l0.1 1.3-0.7 0.3-0.8-1-0.6-0.7h-2.8l-0.6 0.7-0.8 0.9-0.7-0.3 0.1-1.3v-0.9l-0.6-0.5-1.3-1.3h-0.9l-1.3 0.1-0.3-0.7 1-0.8 0.7-0.6v-2.8l-0.7-0.6-1-0.8 0.3-0.7 1.3 0.1h0.9l1.9-1.9v-0.9l-0.1-1.3 0.7-0.3 0.8 1 0.6 0.7h2.8l0.6-0.7 0.8-0.9 0.7 0.3-0.1 1.3v0.9l0.6 0.5 1.3 1.3h0.9l1.3-0.1 0.3 0.7-1 0.8-0.7 0.6v2.8l0.7 0.6 0.9 0.8-0.2 0.7z"></path>
    <path d="M10 6.3c-2 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7c2 0 3.7-1.7 3.7-3.7s-1.7-3.7-3.7-3.7zM10 11.7c-0.9 0-1.7-0.8-1.7-1.7s0.8-1.7 1.7-1.7c0.9 0 1.7 0.8 1.7 1.7s-0.8 1.7-1.7 1.7z"></path>
  </symbol>
</svg>

